import SpriteSymbol from "../../../../../../svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "update",
  "use": "update-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"update\"><path d=\"M12.29 7.29L9 10.59 7.71 9.3a.996.996 0 10-1.41 1.41l2.71 2.71 4.71-4.71a.996.996 0 000-1.41 1.02 1.02 0 00-1.43-.01zM2 10c0-4.41 3.59-8 8-8 2.02 0 3.85.76 5.26 2H13v2h6V0h-2v2.89A9.93 9.93 0 0010 0C4.49 0 0 4.49 0 10c0 .34.02.67.05 1h2.02c-.04-.33-.07-.66-.07-1zm17.95-1h-2.02c.04.33.07.66.07 1 0 4.41-3.59 8-8 8-2.02 0-3.85-.76-5.26-2H7v-2H1v6h2v-2.89A9.93 9.93 0 0010 20c5.51 0 10-4.49 10-10 0-.34-.02-.67-.05-1z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol